import { Box, SkeletonBox } from "@hightouch/htui";

import { MEDIA_DETAIL_FIELD_GRID } from "src/components/media-detail/constants";

/** Stands in for a `MediaDetailField`; wrap a group of them in `Skeleton`. */
export function MediaDetailFieldSkeleton() {
  return (
    <Box {...MEDIA_DETAIL_FIELD_GRID} alignItems="center">
      <SkeletonBox height={4} width={20} borderRadius="sm" />
      <SkeletonBox height={5} width={24} borderRadius="sm" />
    </Box>
  );
}
